import React from 'react'

export default function SamplePappers() {
  return (
    <div>SamplePappers</div>
  )
}
